<template>
  <v-layout column>
    <v-toolbar dense ref="aToolbar" flat>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text :disabled="!mSearch.own" @click="onSave()" color="primary"><v-icon>mdi-floppy</v-icon>&nbsp;{{ $t('GENERIC_SAVE') }}</v-btn><br /><!-- mdi-content-save-outline -->
        <v-btn text :disabled="!mSearch.item" @click="onSaveAs()"><v-icon>mdi-floppy</v-icon>&nbsp;{{ $t('GENERIC_SAVEAS') }}</v-btn><br /><!-- mdi-content-save-settings-outline -->
        <v-btn text :disabled="!mSearch.own || !mSearch.item" @click="onDelete()" color="red darken-1"><v-icon>mdi-trash-can-outline</v-icon>&nbsp;{{ $t('GENERIC_DELETE') }}</v-btn><br />
        <v-btn text :disabled="!dirty" @click="editSearch(mSearch.item || 'new')"><v-icon>mdi-close-box-outline</v-icon>&nbsp;{{ $t('GENERIC_DISCARD') }}</v-btn><br />
<v-btn v-if="isDebug" fab small color="grey lighten-3" class="btn-debug" @click="debug=!debug"><v-icon>mdi-bug-outline</v-icon></v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card>
      <v-card-text>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="mSearch.name"
                  :rules-="[rules.required]"
                  :label="$t('EXTSEARCH_NAME')"
                  data-qa="searchFieldCenter"
                  @change="dirty=true"
                ></v-text-field>
                <p>{{ $t('EXTSEARCH_USAGE_TOTAL_1') }} <strong>{{ $t('EXTSEARCH_USAGE_TOTAL_2', [mSearch.count]) }}</strong></p>
<v-chip v-if="debug" label>fLoading: {{ fLoading }}</v-chip>
              </v-flex>
              <v-flex xs12 sm6 text-xs-right>
                <v-btn
                  color="blue darken-1"
                  dark
                  data-qa="runSearch-button-1"
                  @click.stop="onRun()"
                >{{ $t('EXTSEARCH_PREVIEW_SEARCH') }}&nbsp;<v-icon>mdi-play-circle-outline</v-icon></v-btn>
              </v-flex>
              <v-flex xs12>
                <v-subheader>
                  {{ $t('EXTSEARCH_CONFIG') }}
                </v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-sheet color="grey lighten-3">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex>
                        <SearchViewBlock
                          v-for="(block, idx) in mSearch.blocks"
                          :key="idx"
                          :block="block"
                          @remove="removeBlock(idx)"
                          :debug="debug"
                          :fLoading="fLoading"
                          :isDirty="dirty"
                          @dirty="dirty=true"
                        />
                        <div class="text-xs-center">
                          <v-btn @click="addBlock()">{{ $t('EXTSEARCH_ADD_SEARCH_BLOCK') }}</v-btn>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-sheet>
              </v-flex>
              <v-flex offset-sm6 text-xs-right>
                <v-btn
                  color="blue darken-1"
                  dark
                  @click.stop="onRun()"
                >{{ $t('EXTSEARCH_PREVIEW_SEARCH') }}&nbsp;<v-icon>mdi-play-circle-outline</v-icon></v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>

    <Dialog ref="dialog" />

  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchViewBlock from './SearchViewBlock'
import Dialog from './common/Dialog'
import { SearchModel, SearchModelBlock } from '../models/SearchModel'
import Search from '../services/Search'


export default {
  name: 'SearchView',
  components: {
    SearchViewBlock,
    Dialog
  },
  props: ['id', 'refToolbar'],
  data() {
    return {
      debug: false,
      dirty: false,
      initState: null,
      block: {
        // TODO: rework this to use SearchBlockModel
        searches: [{
          field: null,
          compare: null,
          values: [''],
          date: {
            year: null,
            month: null,
            day: null,
            hour: null,
            minute: null
          },
        }]
      },
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      fLoading: false,
    }
  },
  computed: {
    ...mapGetters(['isDebug', 'data', 'isUnsavedXml', 'mSearch', 'selectedFolder'])
  },
  watch: {
    id(val) {
      this.editSearch(val)
    },
    mSearch() {
      this.$nextTick(() => {
        this.fLoading = false
        this.dirty = false
      })
    },
  },
  mounted() {
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)
    // TODO: add block only if new Search and empty Blocks
    // Obsolete: clear the model
    //this.mSearch.blocks = [_.cloneDeep(this.block)]
    this.editSearch(this.id)
  },
  methods: {
    editSearch(id) {
      if (id) {
        this.fLoading = true
        if (id !== 'new' && id !== 'all') {
          new Search(this.$api).load(id)
        } else {
// console.log(this.isUnsavedXml)
          if (!this.isUnsavedXml) {
            this.$store.commit('setMSearch', new SearchModel(true))
          } else {
            this.fLoading = false
          }
        }
      }
    },
    addBlock() {
// console.log('addBlock')
      this.mSearch.blocks.push(new SearchModelBlock(true))
      this.dirty = true
    },
    removeBlock(idx) {
// console.log('removeBlock')
      idx > -1 && this.mSearch.blocks.splice(idx, 1)
      this.dirty = true
    },
    onSave() {
      if (!this.mSearch.name) {
        this.$refs.dialog.show({
          // type: 'info',
          type: 'warning',
          title: this.$t('EXTSEARCH_ENTER_NAME_TITLE'),
          message: this.$t('EXTSEARCH_ENTER_NAME'),
        })
        return
      }
      if (this.validateForm()) {
        this.$store.commit('setMSearch', this.mSearch)
        if (this.mSearch.item) {
          new Search(this.$api).update(this.mSearch.name, 'search')
            .then(() => {
              this.dirty = false
              this.$router.replace({ name: 'search', params: { id: this.mSearch.item, title: this.mSearch.name }, hash: this.getNewHash() })
            })
        } else {
          new Search(this.$api).create(this.mSearch.name, 'search', this.selectedFolder)
            .then(() => {
              this.dirty = false
// console.log(this.mSearch)
              this.$router.replace({ name: 'search', params: { id: this.mSearch.id, title: this.mSearch.name }, hash: this.getNewHash() })
           })
        }
      }
    },
    onSaveAs() {
      this.$refs.dialog.show({
        // type: 'info',
        type: 'confirm',
        title: this.$t('EXTSEARCH_SAVEAS_HEADER'),
        message: '',
        query: {
          name: {
            label: this.$t('EXTSEARCH_NAME'),
            value: this.mSearch.name
          }
        },
        buttons: [
          {
            label: this.$t('GENERIC_SAVE'),
            close: true,
            default: true,
            callback: res => {
// console.log(res)
              // if (this.mSearch.name !== res.name.value) {
                this.mSearch.name = res.name.value
                this.mSearch.item = null
                this.onSave()
              // }
            },
          },
          {
            label: this.$t('GENERIC_CANCEL'),
            close: true,
            // callback: res => {}
          }
        ]
      })
      // this.mSearch = name
      // this.onSave()
    },
    validateForm() {
      let invalid = null, BreakException = {}
      try {
        this.mSearch.blocks.forEach(block => {
          block.searches.forEach(search => {
// console.log(search)
            if (!search.field) {
// console.log('missing field')
              invalid = 'field'
              throw BreakException
            }
            if (!search.compare) {
// console.log('missing compare')
              invalid = 'compare'
              throw BreakException
            }
            switch (search.field.datatype) {
              case 'date' :
                if (!search.date.year) {
// console.log('missing date.year')
                  invalid = 'date'
                  throw BreakException
                }
                break
              case 'catlist' :
                if (['equals', 'equals-not'].includes(search.compare.id) && search.values.length == 1 && !search.values[0]) {
// console.log('missing category')
                  invalid = 'category'
                  throw BreakException
                }
                break
              default :
                if (!['null', 'null-not'].includes(search.compare.value)) {
                  if (search.values.length == 1 && !search.values[0] && search.field.datatype !== 'checkbox') {
// console.log('empty value')
                    invalid = 'empty value'
                    throw BreakException
                  }
                  if (!search.values.length) {
// console.log('missing values')
                    invalid = 'values'
                    throw BreakException
                  }
                }
            }
          })
        })
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      if (invalid) {
        this.$refs.dialog.show({
          // type: 'info',
          type: 'warning',
          title: this.$t('EXTSEARCH_INVALID_TITLE'),
          message() {
            let reason = ''
            switch (invalid) {
              case 'field':
                reason = this.$t('EXTSEARCH_INVALID_FIELD')
                break
              case 'date':
                reason = this.$t('EXTSEARCH_INVALID_DATE')
                break
              case 'category':
                reason = this.$t('EXTSEARCH_INVALID_CATEGORY')
                break
            }
            return this.$t('EXTSEARCH_INVALID') + ' ' + reason
          },
        })
      }
      return !invalid
    },
    onRun() {
      if (this.validateForm()) {
        // if (this.dirty) {
          this.$store.commit('setIsUnsavedXml', true)
          this.dirty = false // allow route to navigate
        // }
        this.$store.commit('setMSearch', this.mSearch)
        this.$router.push({ name: 'contact.extended_search', params: { search_id: 'new', title: this.mSearch.name ? this.mSearch.name : '-' }, hash: this.getNewHash()})
      }
    },
    onDelete() {
      this.$refs.dialog.show({
        type: '',
        title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
        message: this.$t('NAVI_CONFIRM_DELETE_SEARCH', [this.mSearch.name]),
        buttons: [
          {
            label: this.$t('GENERIC_DELETE'),
            close: true,
            // default: true,
            danger: true,
            callback: () => {
// console.log('is_in_use')
              new Search(this.$api).is_in_use(this.mSearch.item)
              .then(() => {
// console.log('delete', this.searchIsInUse)
                if (!this.searchIsInUse) {
                  new Search(this.$api).delete(this.mSearch.item)
                  .then(() => {
                    this.$router.push({ name: 'mailings', hash: this.getNewHash()}) // go back Home
                    new Search(this.$api).list()
                  })
                } else {

                  // TODO: implement Critical usage // EXTSEARCH_USAGE_DELETION_IMPOSSIBLE

                  let mailings = '<pre>Status : Name\n' + this.searchUsedInMailings.map(a => `${a.status} : ${a.name}\n`) + '</pre>'
                  this.$refs.dialog.show({
                    type: '',
                    title: this.$t('EXTSEARCH_USAGE_DELETION_POSSIBLE'),
                    message: this.$t('EXTSEARCH_USAGE_PANEL_DESC') + mailings,
                    buttons: [
                      {
                        label: this.$t('GENERIC_DELETE'),
                        close: true,
                        // default: true,
                        danger: true,
                        callback: () => {
// console.log('is_in_use & delete')
                          new Search(this.$api).delete(this.mSearch.item)
                          .then(() => {
                            this.$router.push({ name: 'mailings', hash: this.getNewHash()}) // go back Home
                            new Search(this.$api).list()
                          })
                        }
                      },
                      {
                        label: this.$t('GENERIC_CANCEL'),
                        close: true,
                        // default: true,
                        // callback: res => {},
                      },
                    ]
                  })
                }
              })
            },
          },
          {
            label: this.$t('GENERIC_CANCEL'),
            close: true,
            // default: true,
            // callback: res => {},
          },
        ]
      })
    },
    onLeave(next) {
      if (this.dirty) {

        next(false)
        this.$refs.dialog.show({
          type: '',
          title: this.$t('GENERIC_UNSAVED_CHANGES_TITLE'),
          message: this.$t('GENERIC_UNSAVED_CHANGES'),
          buttons: [
            {
              label: this.$t('GENERIC_SAVE'),
              close: true,
              default: true,
              callback: () => {
                this.onSave()
                next()
              },
            },
            {
              label: this.$t('GENERIC_DISCARD'),
              close: true,
              default: true,
              callback: () => {
                this.$store.dispatch('restoreMSearch')
                next()
              },
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
              // default: true,
              // callback: res => {},
            },
          ]
        })

      } else {
        next()
      }
    },
    appReload(e) {
      if (this.dirty) {
        e.preventDefault()
        e.returnValue = 'Please save' // Chrome only
        return 'Please save' // legacy
      }
    },
    getNewHash() {
      const dt = new Date()
      return '##'+ (dt.getTime()*1000 + dt.getMilliseconds())
    }
  },
  beforeRouteUpdate(to, from, next) {
// console.log('beforeRouteUpdate')
    this.onLeave(next)
  },
  beforeRouteLeave(to, from, next) {
// console.log('beforeRouteLeave')
    this.onLeave(next)
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.appReload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.appReload)
    this.$refs.aToolbar.$el.remove()
  },
}
</script>

<style>
.container {
  padding: 12px;
}
.v-card__title {
  position: relative;
}
</style>
